module.exports = __webpack_public_path__ + "img/arrow-left.ba02f618.svg";